import {
  getReportsGroupsFiltered,
  createGroupsReportsFilter,
  getGroupsReportsFilter,
  createExportGroupsReports,
} from '@/service/comparation'

// initial state
function initialState() {
  return {
    selectedGroups: [],
    groupsReports: [],
    userFilters: [],
    userFilterAddLoading: false,
  }
}

const state = initialState()

// getters
const getters = {
  selectedGroups: state => state.selectedGroups,
  groupsReports: state => state.groupsReports,
  userFilters: state => state.userFilters,
  userFilterAddLoading: state => state.userFilterAddLoading,
}

// actions
const actions = {
  async loadReportsGroupsFiltered({ commit }, groups) {
    const {
      data: { groups_data },
    } = await getReportsGroupsFiltered(groups)

    commit('setGroupsReports', groups_data)
  },
  updateSelectedGroups({ commit }, groups) {
    commit('setSelectedGroups', groups)
  },
  async saveUserFilter({ commit }, filters) {
    commit('setUserFilterAddLoading', true)
    await createGroupsReportsFilter(filters)
    commit('setUserFilters', filters)
    commit('setUserFilterAddLoading', false)
  },
  async loadUserFilters({ commit }) {
    const {
      data: { groupsFilters },
    } = await getGroupsReportsFilter()

    commit('setUserFilters', groupsFilters)
  },
  async saveExportGroupsReports(_, groups) {
    await createExportGroupsReports(groups)
  },
}

// mutations
const mutations = {
  setSelectedGroups(state, groups) {
    state['selectedGroups'] = groups
  },
  setGroupsReports(state, reports) {
    state['groupsReports'] = reports
  },
  setUserFilterAddLoading(state, loading) {
    state['userFilterAddLoading'] = loading
  },
  setUserFilters(state, filters) {
    state['userFilters'] = filters
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
